import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addWarningNotification, getFilmAvailability, NotificationType, removeMemberWatchlistFilm } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { FilmCategory } from '@vista-digital/ocapi-types/v1';
import { motion } from 'framer-motion';
import { observer } from 'mobx-react';
import { useCallback, useMemo } from 'react';
import { FilmContextInstance } from '../../../context/film/types/context';
import { Icon } from '../../../subcomponents/icon/icon';
import { Link } from '../../../subcomponents/link/link';
import { PromotedTagAlignment } from '../../../subcomponents/promoted-tag';
import { getIdForComponentNotification } from '../../../utils/get-id-for-component-notification';
import { FilmPromotedTag } from '../../film/promoted-tag/film-promoted-tag';
import { FilmTrailerButton } from '../../film/trailer-button/film-trailer-button';
import { MemberFilmWatchlistFilmButton } from './film-button';
import { MemberFilmWatchlistFilmDetails } from './film-details';
const b = bemClassBuilder('v-member-film-watchlist-film');
export const MemberFilmWatchlistFilm = observer(props => {
    const { assets, displayText, film, config, events, cdnOptions } = props;
    const { onFilmClicked, onFilmRemoved } = events;
    const { filmUrlFactory, playTrailerButton } = config;
    const handleRemoveClick = useCallback(async () => {
        try {
            await removeMemberWatchlistFilm(film.id);
            onFilmRemoved === null || onFilmRemoved === void 0 ? void 0 : onFilmRemoved(film);
        }
        catch (error) {
            addWarningNotification({
                id: getIdForComponentNotification('memberFilmWatchlist', NotificationType.Warning, 'failed-to-remove-film'),
                messages: [displayText.failedToRemoveFilm]
            });
        }
    }, [displayText.failedToRemoveFilm, film, onFilmRemoved]);
    const filmUrl = useMemo(() => filmUrlFactory === null || filmUrlFactory === void 0 ? void 0 : filmUrlFactory(film), [filmUrlFactory, film]);
    const handleClick = useCallback(() => {
        onFilmClicked === null || onFilmClicked === void 0 ? void 0 : onFilmClicked(film);
    }, [film, onFilmClicked]);
    const filmAvailability = getFilmAvailability(film.id);
    const hasFilmDetailsPage = isFilmDetailsPageAvailable(filmAvailability);
    const filmTrailerButtonProps = {
        displayText,
        assets,
        events,
        config: config.playTrailerButton
    };
    return (_jsx(FilmContextInstance.Provider, Object.assign({ value: { filmId: film.id, film, filmAvailability } }, { children: _jsxs(motion.li, Object.assign({ className: b.block({ unavailable: !hasFilmDetailsPage }), layout: "position", exit: { opacity: 0, transition: { duration: 0.2 } } }, { children: [hasFilmDetailsPage && (_jsxs(Link, Object.assign({ className: b.element('link'), href: filmUrl, onClick: onFilmClicked && handleClick }, { children: [_jsx(FilmPromotedTag, { config: { alignment: PromotedTagAlignment.Center } }), _jsx(MemberFilmWatchlistFilmDetails, { filmMediaType: config.filmMediaType, cdnOptions: cdnOptions })] }))), !hasFilmDetailsPage && (_jsx(MemberFilmWatchlistFilmDetails, { filmMediaType: config.filmMediaType, cdnOptions: cdnOptions })), _jsxs("div", Object.assign({ className: b.element('buttons-wrapper') }, { children: [_jsx("button", Object.assign({ onClick: handleRemoveClick, className: b.element('remove-button') }, { children: _jsx(Icon, { name: assets.removeFilmButtonIconName, className: b.element('remove-button-icon') }) })), playTrailerButton.show && _jsx(FilmTrailerButton, Object.assign({}, filmTrailerButtonProps)), _jsx(MemberFilmWatchlistFilmButton, { onClick: handleClick, displayText: displayText })] }))] })) })));
});
MemberFilmWatchlistFilm.displayName = 'MemberFilmWatchlistFilm';
const isFilmDetailsPageAvailable = (filmAvailability) => {
    if (!filmAvailability)
        return false;
    const { categories } = filmAvailability;
    return categories.includes(FilmCategory.ComingSoon) || categories.includes(FilmCategory.NowShowing);
};
